import Drawer, { drawerClasses } from '@mui/material/Drawer';
import { styled } from '@mui/material';

const StyledSessionDrawer = styled(Drawer)(({ theme }) => ({
  [`& .${drawerClasses.paper}`]: {
    background: theme.palette.surface.sidebar,
    backgroundImage: 'none',
    borderLeft: `1px solid ${theme.palette.hairline.main}`,
    boxShadow: theme.palette.shadow.menu,
    padding: `${theme.spacing(4)} ${theme.spacing(3)}`,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '400px'
    }
  }
}));

export default StyledSessionDrawer;
